import React, { useContext, useEffect, useState} from 'react';
import {IProps, IState} from './types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import Button from '@components/Button';
import * as S from './styles';
import C from '@assets/themes/colors';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { IBrand, IBrandFont } from '@state/brands/types'
import { IElementUpdate, IActionInfo,IDeleteBrand, IBrandColor} from '../../../../../state/brands/types';
import { IBrandImage } from '@state/brandsImages/types';

const uuid = require('react-uuid');

const imageFileTypes = [
  'image/png', 'image/jpeg', 'image/svg+xml'
];


const DeleteBrand:React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);
  const { brandAction, brandDetail, setBrandDetail, addUpdateBrand, deleteBrand, setBrandAction, movefile} = useContext(BrandsContext);
  const moveFileResponse = useSelector(selectors.brands.getMoveFileResponse);
  const deletedBrand = useSelector(selectors.brands.getdeletedBrand);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const brandItem = props.item  as IBrand  


  const updateBrand = (newFile?: string) => {
    let element : any  = {...brandAction.element};
    let newAction : IActionInfo = {
      user: {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      },
      date: new Date(),
      action:"DELETE"
    }
    element.actions.push(newAction);

    if (newFile) {
      element.srcImage = newFile.split('.')[0];
      element.format = newFile.split('.')[1];
      element.status = "INACTIVE";
    }

    let updateInfo : IElementUpdate = {
      action: "DELETE", //INSERT DELETE UPDATE
      field: brandAction.section.toUpperCase(),
      value: element
    }
    addUpdateBrand([updateInfo]);
  }

  const handleDelete = () => {
    if(brandItem) {
      setIsDeleting(true)
      deleteBrand(brandItem.id)      
    }
  }  

  useEffect(()=>{
    if (deletedBrand)
    {
      setIsDeleting(false);      
      if (props && props.onActions)
        props.onActions(props.item, "CANCELDELETEBRAND")             
      
    }

  },[deletedBrand])


  const getCounterAverage=(images:IBrandImage[])=>{

    let designsCount=0;
    let templatesCount=0;

    images.map((value:IBrandImage, index:number)=>{
      designsCount+= value.designsCount??0;
      templatesCount+= value.templatesCount??0;
    })


    return {designsCount,templatesCount}

  }

  const getCounterFonts=(fonts:IBrandFont[])=>{

    let designsCount=0;
    let templatesCount=0;

    fonts.map((value:IBrandFont, index:number)=>{
      designsCount+= value.designsCount??0;
      templatesCount+= value.templatesCount??0;
    })


    return {designsCount,templatesCount}

  }

  const getImagesSummary=(images:IBrandImage[], type:string)=>{
    if (images && images.length>0)
    {      
      let {designsCount, templatesCount } = getCounterAverage(images);

      let message = `${images.length} ${type} used at least `

      if (templatesCount>0)
        message+= `in one template `
      if (designsCount>0)
        message+= ` ${(templatesCount>0)?` and `:``} in one desing `      
  
      return(
        <S.SummaryText>            
        {message}
        </S.SummaryText>
      ) 
    }
    else
      return (<></>)
  }
  const getFontsSummary=(fonts:IBrandFont[], type:string)=>{  
    if (fonts && fonts.length>0)
    {      
      let {designsCount, templatesCount } = getCounterFonts(fonts);

      let message = `${fonts.length} ${type} used at least `

      if (templatesCount>0)
        message+= `in one template `
      if (designsCount>0)
        message+= ` ${(templatesCount>0)?` and `:``} in one desing `      
  
      return(
        <S.SummaryText>            
        {message}
        </S.SummaryText>
      ) 
    }
    else
      return (<></>)
  }

  const getDeleteMessage=()=>{     
    let usedLogos: any;             
    let usedVehicles: any;             
    let usedBackgrounds: any;             
    let usedStocks: any;             
    let usedFonts: any;             
    if (brandItem && brandItem.logos)      
      usedLogos = brandItem.logos.filter(f=> f.designsCount>0 || f.templatesCount>0);             
    if (brandItem && brandItem.vehicles)      
      usedVehicles = brandItem.vehicles.filter(f=> f.designsCount>0 || f.templatesCount>0);
    if (brandItem && brandItem.backgrounds)      
      usedBackgrounds = brandItem.backgrounds.filter(f=> f.designsCount>0 || f.templatesCount>0);
    if (brandItem && brandItem.stocks)      
      usedStocks = brandItem.stocks.filter(f=> f.designsCount>0 || f.templatesCount>0);
    if (brandItem && brandItem.fonts)      
      usedFonts =  brandItem.fonts.filter(f=> f.designsCount>0 || f.templatesCount>0);
      //let usedFonts = brandItem..fonts.filter(f=> f.designsCount>0 || f.templatesCount>0);
      return (
        <>
        <S.SummaryMessage>
        {(usedLogos && usedLogos.length>0) || (usedVehicles && usedVehicles.length>0) || (usedBackgrounds && usedBackgrounds.length>0) || (usedStocks && usedStocks.length>0) || (usedFonts && usedFonts.length>0) ?
          `If you delete this brand library, the files will reflect the next changes. `
          :
          `Are you sure you want to delete this brand library?`
        }
        </S.SummaryMessage>
        <S.Summary>
        {
          getImagesSummary(usedLogos,'logos')
        }
        {
          getImagesSummary(usedVehicles,'vehicles')
        }
         {
          getImagesSummary(usedBackgrounds,'backgrounds')
        }
         {
          getImagesSummary(usedStocks,'stocks')
        }   
        {
          getFontsSummary(usedFonts,'fonts')
        }                  
        </S.Summary>       
        </>

      )


  }

  const elementNameSplitted = props.elementName.split(' ');

  return (
    <S.Root style={{
      display: props.open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
            Delete Brand
            </S.Title>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
            {getDeleteMessage()}
        </S.Content>
        <S.ActionsContainer>
          <S.Action>
            <Button
              label="CANCEL"
              style={{
                width: '112px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.BLUE}`, 
                hoverBackgroundColor: `${C.BLUE}22`,
              }}
              labelStyle={{color: C.BLUE}}
              onClick={() => {
                if (props && props.onActions)
                  props.onActions(props.item, "CANCELDELETEBRAND")             
                }
              }
              disabled={isDeleting}
            />
          </S.Action>
          <S.Action>
            <Button
              label={isDeleting ? "DELETING..." : "DELETE"}
              style={{
                width: '112px',
                backgroundColor: C.BLUE, 
                flexGrow: 0, 
                hoverBackgroundColor: `${C.BLUE}AA`,
              }} 
              onClick={()=>handleDelete()}
              disabled={isDeleting}
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default DeleteBrand;